import moment from 'moment';
import 'moment/locale/de';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/ro';

const locale =
  (window.navigator as any).userLanguage || window.navigator.language; // any for browser support
moment.locale(locale);
